let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

/**
 * Subscriber isolation.
 *
 * Stock Dawn maps over subscribers with no error handling, so a single
 * subscriber that throws propagates synchronously out of publish() and aborts
 * whatever called it. In practice that meant one broken listener could kill
 * the entire add-to-cart render chain in product-form.js. Each callback is now
 * isolated: it is allowed to fail loudly in the console without taking the
 * other subscribers -- or the caller -- down with it.
 */
function publish(eventName, data) {
  if (subscribers[eventName]) {
    const promises = subscribers[eventName].map((callback) => {
      try {
        return Promise.resolve(callback(data)).catch((error) => {
          console.error('[pubsub] async subscriber for "' + eventName + '" rejected; continuing.', error);
          return undefined;
        });
      } catch (error) {
        console.error('[pubsub] subscriber for "' + eventName + '" threw; continuing.', error);
        return undefined;
      }
    });
    return Promise.all(promises);
  } else {
    return Promise.resolve();
  }
}
